var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WeEditor',{attrs:{"name":"page-editor","id":_vm.componentId,"access-token":_vm.session.accessToken},model:{value:(_vm.computedData),callback:function ($$v) {_vm.computedData=$$v},expression:"computedData"}})}
var staticRenderFns = []

export { render, staticRenderFns }